import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3';
import TopicEmbedPublic from '@/pages/export/topic-embed-public'

const searchSchema = z.object({
  topicId: z.string().optional(),
  docId: z.string().optional(),
  token: z.string().optional(),
  theme: z.enum(['light', 'dark']).optional().default('light'),
})

export const Route = createFileRoute('/export/topic-embed/')({
  validateSearch: searchSchema,
  component: TopicEmbedPublic,
})